import * as NavigationActions from './actions';

const initialState = {
  previousPathname: null,
  navBarWidth: null,
  navBarHeight: null,
  navBarActive: null
}

const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NavigationActions.NAVIGATION_CHANGE_PAGE: {
      return {
        ...state,
        previousPathname: action.previousPathname
      }
    }
    case NavigationActions.HORIZHEIGHT_DETERMINDED: {
      return {
        ...state,
        navBarWidth: action.navBarWidth,
        navBarHeight: action.navBarHeight,
        navBarActive: action.navBarActive
      }
    }
    default: {
      return state;
    }
  }
}

export default navigationReducer;
